import ElementTemplateCommands from './ElementTemplateCommands';

export default {
  __init__: [ 'elementTemplateCommands' ],
  elementTemplateCommands: [ 'type', ElementTemplateCommands ]
};